import { render, staticRenderFns } from "./SalePersonDashboard.vue?vue&type=template&id=0b3d583e&"
import script from "./SalePersonDashboard.vue?vue&type=script&lang=js&"
export * from "./SalePersonDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports